import {
  SET_DAILY_CRON_LOGS,
} from './types';
import { SetRegValueHelper, SpreadOps } from '../helper';

const initialState = {
  list: [],
  count: 0,
};

var temp = "";
initialState.values = SpreadOps({ ...initialState.default });

export default function (state = initialState, action) {
  switch (action.type) {

    case SET_DAILY_CRON_LOGS:
      return {
        ...state,
        list: action.data.list,
        count: action.data.count,
      }

    default:
      return state

  }
}
